// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/photo-sphere-viewer/dist/photo-sphere-viewer.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".czt-panorama__container{position:relative;width:100%;height:100%;min-height:100%;min-width:100%;z-index:0}.czt-panorama .psv-overlay-image{margin-bottom:1rem;max-width:25%}.czt-panorama .psv-overlay-image svg{width:100%}.czt-panorama .psv-overlay-text{font-size:1.25rem}", ""]);
// Exports
module.exports = exports;
